import { createFileRoute } from '@tanstack/react-router';

import { ClaimView } from 'src/sections/client-transfer/claim-view';

export const Route = createFileRoute('/client-transfers/claim/$token')({
  component: ClaimPage,
});

function ClaimPage() {
  const { token } = Route.useParams();
  return <ClaimView token={token} />;
}
